import { isEmpty, isNil } from "lodash";
import {
  DOCUMENT_TEMPLATE_AREAS,
  DOCUMENT_TEMPLATE_MOMENTS,
  DOCUMENT_TEMPLATE_STATES,
  DOCUMENT_TEMPLATE_STATUSES,
} from "utils/constants";

export const MOMENT_OPTIONS = [
  {
    value: DOCUMENT_TEMPLATE_MOMENTS.QUOTE,
    area: DOCUMENT_TEMPLATE_AREAS.QUOTE,
  },
  {
    value: DOCUMENT_TEMPLATE_MOMENTS.SUBSCRIPTION,
    area: DOCUMENT_TEMPLATE_AREAS.SUBSCRIPTION,
  },
  { value: DOCUMENT_TEMPLATE_MOMENTS.BOTH, area: null },
];

export const normalizeArea = (area) => (isEmpty(area) ? null : area);

export const momentOfArea = (area) =>
  MOMENT_OPTIONS.find((option) => option.area === normalizeArea(area));

export const areaOfMoment = (moment) =>
  MOMENT_OPTIONS.find((option) => option.value === moment)?.area ?? null;

export const momentKey = (area) => momentOfArea(area)?.value;

export const areasOverlap = (left, right) => {
  const a = normalizeArea(left);
  const b = normalizeArea(right);
  return isNil(a) || isNil(b) || a === b;
};

export const usesOverlap = (left, right) =>
  !isNil(left?.insurancePlanId) &&
  left.insurancePlanId === right?.insurancePlanId &&
  areasOverlap(left.area, right.area);

export const overlappingUseIndexes = (uses = []) => {
  const indexes = new Set();
  for (const [index, use] of uses.entries()) {
    for (const [offset, other] of uses.slice(index + 1).entries()) {
      if (!usesOverlap(use, other)) continue;
      indexes.add(index);
      indexes.add(index + 1 + offset);
    }
  }
  return [...indexes].sort((a, b) => a - b);
};

export const usesFromUsages = (usages = []) =>
  (usages || []).map(
    ({ insurancePlanId, type, area, outputName, conditions }) => ({
      insurancePlanId,
      type: type ?? null,
      area: normalizeArea(area),
      outputName: outputName || null,
      conditions: conditions ?? null,
    }),
  );

export const documentState = (template) => {
  const neverPublished =
    template?.status === DOCUMENT_TEMPLATE_STATUSES.DRAFT &&
    isNil(template?.publishedAt) &&
    isEmpty(template?.usages);
  if (neverPublished) return DOCUMENT_TEMPLATE_STATES.DRAFT;
  if (template?.hasUnpublishedChanges) return DOCUMENT_TEMPLATE_STATES.CHANGED;
  return DOCUMENT_TEMPLATE_STATES.PUBLISHED;
};
